<img *ngIf="routeparam?.detailsEntered && isRepeater" src="{{trackierSource}}" />
<section class="thankyou-banner">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="thankyou-content">
                    <img src="assets/img/check-circle.png">
                    <h1>Thank You!</h1>
                    <h6>Make your learning Infinite and <span class="label label-danger">fun</span></h6>
                </div>
            </div>
        </div>
    </div>
    </section>
    <section class="user-sec">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-md-12 col-xs-12">
                    <div class="user-content">
                        <div class="user-head">
                            <h1>Hi, {{routeparam?.firstname || 'User'}} {{routeparam?.lastname}}</h1>
                            <p>Welcome to Infinity Learn!<br>
                            You have successfully enrolled for {{routeparam.source}}</p>
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="contact-sec">
    <div class="container">
        <div class="row">
            
            <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="learnbtncenter m-auto d-flex justify-content-center">
                    <a><button (click)='navigateToDashboard()' type="button" class="congrtas-startlearnbtn">START LEARNING</button></a>
                </div>
                <div class="query-contact m-auto d-flex flex-column align-items-center">
                    <h4>For more query,  we are available here</h4>
                    <ul class="congrats-contact">
                        <li><img src="assets/img/phone-icon.svg" ><span class='mobno'>9019846666</span></li>
                        <li><img src="assets/img/neet-landing/mail.png" aria-hidden="true"><a href="mailto:info@infinitylearn.com">info@infinitylearn.com</a></li>
                    </ul>
                </div>
            </div>
            <!--div class="col-md-6 offset-md-3">
                <div class="form-container">
                    <h3>We are available here</h3>
                    <div class="list-center">
                        <ul class="thank-contact">
                            <li><img src="assets/img/phone-icon.svg" ><span class='mobno'>040-66151515</span></li>
                            <li><img src="assets/img/neet-landing/mail.png" aria-hidden="true"><a href="mailto:info@infinitylearn.com">info@infinitylearn.com</a></li>
                        </ul>
                    </div>
    
                </div>
                <div class="text-center">
                    <a><button (click)='navigateToDashboard()' type="button" class="thankyou-btn">START LEARNING</button></a>
                </div>      
            </div-->
        </div>
    </div>
    </section>